declare global {
  interface Window {
    __cl_env: {
      environment: string;
      imgCdnUrl: string;
      apiBaseUrl: string;
      clGTMTag: string;
      openAIApiKey: string;
      admin: {
        storage: {
          publicDocumentsBase: string;
        };
        recaptchaSiteKey: string;
        defaultImportAgencyId: string;
        defaultImportAgencyName: string;
      };
      merlin: {
        variantUrls: {
          alpha: string;
          beta: string;
          stable: string;
        };
      };
    };
  }
}
const {admin, merlin, environment, apiBaseUrl, imgCdnUrl, openAIApiKey} = window.__cl_env;
export {admin, merlin, environment, apiBaseUrl, imgCdnUrl, openAIApiKey};
